<template>
  <div>
    <MemberProfile v-if="PerfilSocioAvanzado" :isCap="true" />
    <ProfileMemberCap v-else />
  </div>
</template>

<script>
import ProfileMemberCap from "./ProfileMemberCap.vue";
import MemberProfile from "../Membership/MemberProfile.vue";

let club = localStorage.getItem("club");
try {
  if (JSON.parse(localStorage.getItem("club")))
    club = JSON.parse(localStorage.getItem("club"));
} catch (error) {
  console.log("Error parsing club from localStorage");
  club = null;
}

export default {
  name: "ProfileMemberRouter",
  data() {
    return {
      advanced: false,
      PerfilSocioAvanzado: club && club.PerfilSocioAvanzado,
    };
  },
  components: {
    ProfileMemberCap,
    MemberProfile,
  },
  methods: {},
};
</script>
